export default class UtilService {
  public static applyIfNeeded(scope: angular.IScope) {
    /*eslint angular/no-private-call: [2,{"allow":["$$phase"]}]*/
    if (!scope.$$phase && !scope.$root.$$phase) {
      scope.$apply();
    }
  }

  public static deepCopy(obj) {
    return angular.copy(obj);
  }

  public static unrejectable(promise, fallbackResult) {
    return promise.then(data => data, (/*error*/) => fallbackResult);
  }

  public static getElementIndexById(array, id) {
    let i = array.length;
    while (i--) {
      if (angular.equals(array[i].id, id)) {
        return i;
      }
    }
    return -1;
  }

  public static getElementsById(array: any[], id): any[] {
    return array.filter(element => angular.equals(element.id, id));
  }



  public static getElements(array: any[], comparator: (obj) => boolean): any[] {
    return array.filter(element => comparator(element));
  }

  public static getElementIndex(
    array,
    element,
    comparator: (objA, objB) => boolean = angular.equals
  ) {
    let i = array.length;
    while (i--) {
      if (comparator(array[i], element)) {
        return i;
      }
    }
    return -1;
  }

  public static removeElement(array, element) {
    const index = UtilService.getElementIndex(array, element);
    if (index !== -1) {
      return array.splice(index, 1);
    }
  }

  public static removeElementById(array, id) {
    const index = UtilService.getElementIndexById(array, id);
    if (index !== -1) {
      return array.splice(index, 1);
    }
  }

  public static removeElementFromSlider(array, element, slider) {
    const index = UtilService.getElementIndex(array, element);
    if (index !== -1) {
      slider.slick('slickRemove', index);
      array.splice(index, 1);
    }
  }

  public static generateRandomNumber(
    max: number = 1000000,
    min: number = 1
  ): number {
    return Math.floor(Math.random() * (max - min)) + min;
  }

  public static generateUniqueNumber(): number {
    return Date.now() * 100 + UtilService.generateRandomNumber(100);
  }

  public static isBoolean(value): boolean {
    return typeof value === 'boolean';
  }

  /**
   * Validates a msisdn (phone number). It is only valid when it consists of
   * digits exclusively. Any letter (or any other non-digit character) makes it
   * invalid, so it must never be shown in the UI.
   * @param {string} msisdn
   * @returns {boolean}
   */
  public static isValidMsisdn(msisdn): boolean {
    return typeof msisdn === 'string' && /^\d+$/.test(msisdn.trim());
  }

  /**
   * Returns the integer part of a number by removing any fractional digits.
   * Use polyfill because of IE support
   * @param {number} value
   * @returns {number}
   */
  public static trunc(value: number) {
    value = +value;
    return (
      value - value % 1 ||
      (!isFinite(value) || value === 0 ? value : value < 0 ? -0 : 0)
    );
  }

  public static jsonToQueryString(json: any): string {
    return Object.keys(json)
      .map((key, index) => {
        return encodeURIComponent(key) + '=' + encodeURIComponent(json[key]);
      })
      .join('&');
  }

  public static isWithinIframe(): boolean {
    return window.location !== window.parent.location;
  }

  public static getUrlParameter = (name) => {
    var results = new RegExp('[\?&]' + name + '=([^&#]*)').exec(window.location.href);
    if (results==null) {
       return null;
    }
    return decodeURIComponent(results[1]);
  }

  public static safeStringValue = (source: object, value: string): string =>
    source ? source[value] : '';

  public static decodeHtmlCharCodes = str => 
  str.replace(/(&#(\d+);)/g, (match, capture, charCode) => 
    String.fromCharCode(charCode));

  public static getSessionStorageWithExpire(key:string):string{
    const itemStr = sessionStorage.getItem(key);
    if (!itemStr) {
      return null;
    }
    const item = JSON.parse(itemStr);
    const now = new Date();
    if (now.getTime() >= item.expiry) {
      sessionStorage.removeItem(key);
      return null;
    }
    return item.value
  }

  public static setSessionStorageWithExpire(key:string, value:string, ttl: number){
    const now = new Date();
    const item = {
      value: value,
      expiry: now.getTime() + ttl,
    }
    sessionStorage.setItem(key, JSON.stringify(item));
  }

}



// WEBPACK FOOTER //
// src/app/common/services/util.service.ts